import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';

export const IS_CREATIVE_LIBRARY = 'isCreativeLibrary';

export const useIsCreativeLibrary = queryParamHookFactory(IS_CREATIVE_LIBRARY);
